import { type User } from '@qdrant/qdrant-cloud-public-api/iam/v1';
import { type ResolveUserAccountContext } from '@/router/resolvers/user';

export async function resolveAuthenticatedUser(context: ResolveUserAccountContext): Promise<User> {
  const { user } = await context.queryClient.ensureQueryData(context.getAuthenticatedUserQuery);
  if (!user) {
    throw new Error('Authenticated user data is not available');
  }
  return user;
}
